import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  search: {
    method: 'GET',
    url: `${configs.baseUrl}/api/slide/search-tenor`,
    headers: {
      'Cache-Control': 'public, max-age=900', // 900 seconds = 15 minutes
    },
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const search = async (params = {}) => {
  const result = await resource.search({
    limit: params.limit,
    media_filter: params.media_filter,
    searchfilter: params.searchfilter,
    pos: params.pos,
    q: params.q,
  })

  return result.body
}

export default {
  initResource,
  search,
}
